module.exports = __webpack_public_path__ + "static/media/resume.5401f922.svg";